import { useMemo } from 'react';
import { useSelectedSource } from '../components/source-selector/source-selector';
import { camelToSnake } from '../utils/string';
import { useAuthContext } from './useAuthContext';

export function useSources() {
  const { currentAccount } = useAuthContext();
  const { selectedSource, setSelectedSource } = useSelectedSource();

  const sites = (currentAccount?.sites ?? []).map(parseEach);
  const gaProperties = (currentAccount?.gaProperties ?? []).map(parseEach);

  const enabledGaProperties = useMemo(() => {
    return gaProperties.filter((p) => !!p.enabledAt);
  }, [gaProperties]);

  const allSources = useMemo(() => [...sites, ...gaProperties], [sites, gaProperties]);

  const allSelectableSources = useMemo(() => [...sites, ...enabledGaProperties], [sites, enabledGaProperties]);

  return {
    sites,
    gaProperties,
    enabledGaProperties,
    allSources,
    allSelectableSources,
    selectedSource,
    setSelectedSource,
  };
}

function parseEach(input) {
  return {
    ...input,
    type: input.__typename ? camelToSnake(input.__typename).toUpperCase() : null,
    active: input.active ?? null,
    id: input.id,
    installed: input.installed ?? null,
    lastData: input.lastData ?? null,
    name: input.name,
  };
}
